import React from "react";

/**
 * UNSET = null
 * OUTSIDE_ARRANGEMENTS = -1
 * NO_COST = 0
 * NORMAL_COST = 1
 * HIGH_COST = 2
 */
type arrangement_credit_cost = null | -1 | 0 | 1 | 2;

export function ArrangementCreditCostValue({
  value,
  explanation = true,
}: {
  value: arrangement_credit_cost;
  explanation?: boolean;
}) {
  if (value === -1) {
    return (
      <>
        <b>Outside arrangements</b>
        {explanation ? ": No arrangement credit cost and can be ordered outside of the round timer" : null}
      </>
    );
  }

  if (value === 0) {
    return (
      <>
        <b>No cost</b>
        {explanation ? ": No arrangement credit cost, but is part of a new round" : null}
      </>
    );
  }

  if (value === 1) {
    return (
      <>
        <b>Normal cost</b>
        {explanation ? ": 1 credit" : null}
      </>
    );
  }
  if (value === 2) {
    return (
      <>
        <b>High cost</b>
        {explanation ? ": 2 credits" : null}
      </>
    );
  }

  return null;
}
